// extracted by mini-css-extract-plugin
module.exports = {"incidentInfo":"styles_incidentInfo__3zjy8","title":"styles_title__2kVh0","info":"styles_info__3ZKVO"};